export const formatUsdc = (value) => {
  const num = Number(value || 0);
  return num.toFixed(2);
};